import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            本站特色
          </h2>
          <p className="text-foreground-500 text-sm">为什么选择52吃瓜网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-2xl p-6 border border-background-200/60 text-center hover:border-primary-200 transition-colors duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-foreground-800 font-bold text-sm md:text-base mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}